export default "__VITE_ASSET__br1_RT9I__"